<!-- HEADER -->
<div class="grid grid-cols-12 p-3 mb-5 bg-gray-50">
  <div class="col-span-12 lg:col-span-6 border-l-4 border-gray-700 pl-4">
    <div class="grid">
      <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
        Social Posts Section
      </p>
      <h2 class="text-xl font-bold text-nowrap text-gray-700 leading-tight">
        {{ viewMode === 'preview' ? 'Preview' : 'Analytics' }}
      </h2>
    </div>
  </div>
</div>

<!-- TOGGLE ROW -->
<div class="grid grid-cols-1 xl:grid-cols-12" id="toggleRow">
  <div class="col-span-12 2xl:col-span-9 ps-3">
    <div class="w-full flex justify-center mb-1">
      <div class="inline-flex rounded-full border border-gray-200 bg-gray-50 p-1">
        <button
          type="button"
          (click)="setViewMode('preview')"
          class="px-4 py-2 rounded-full text-xs font-semibold transition"
          [ngClass]="viewMode === 'preview'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-600 hover:text-gray-900'">
          Preview
        </button>

        <button
          type="button"
          (click)="setViewMode('analytics')"
          class="px-4 py-2 rounded-full text-xs font-semibold transition"
          [ngClass]="viewMode === 'analytics'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-600 hover:text-gray-900'">
          Analytics
        </button>
      </div>
    </div>
  </div>
</div>


<!-- PREVIEW VIEW -->
<div class="grid grid-cols-1 xl:grid-cols-12" id="grid" *ngIf="viewMode === 'preview'">
  <div class="col-span-12 2xl:col-span-9 ps-3">
    <div class="bg-white border border-gray-200 rounded-2xl p-3 w-full">

      <!-- NESTED GRID -->
      <div class="grid grid-cols-12 gap-4 items-start">
        <!-- LEFT BUTTONS -->
        <div class="hidden md:flex flex-col col-span-1 items-center">
          <span class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="viewList()"
              matTooltip="Done">
              <mat-icon>done_outline</mat-icon>
            </button>
          </span>

          <span *ngIf="enableEdit === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="editPost(id)"
              [disabled]="isEditDisabled"
              matTooltip="Edit">
              <mat-icon>edit</mat-icon>
            </button>
          </span>

          <span *ngIf="enableReuse === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="reusePost()"
              [disabled]="isReuseDisabled"
              matTooltip="Reuse">
              <mat-icon>replay</mat-icon>
            </button>
          </span>

          <span *ngIf="enableDelete === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="openDeleteConfirm()"
              [disabled]="isDeleteDisabled"
              matTooltip="Delete"
              matTooltipPosition="left">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>

          <div class="my-4"></div>

          <span *ngIf="nextId != null" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="nextPost()"
              matTooltip="Next">
              <mat-icon>skip_next</mat-icon>
            </button>
          </span>

          <span *ngIf="prevId != null" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="prevPost()"
              matTooltip="Previous">
              <mat-icon>skip_previous</mat-icon>
            </button>
          </span>
        </div>

        <!-- PREVIEW -->
        <div class="col-span-11 overflow-hidden">
          <ng-container *ngIf="renderPreview">
            <app-facebook-post
              *ngIf="tag=='photolink' || tag=='fbphotopost' || tag=='fbvideo' || tag=='fbfirstcomment'">
            </app-facebook-post>

            <app-facebook-story
              *ngIf="tag=='fbstoryphoto' || tag=='igstoryphoto' || tag=='igstoryvideo'">
            </app-facebook-story>

            <app-instagram-post
              *ngIf="tag=='igphotopost' || tag=='igvideo' || tag=='igcarousel'">
            </app-instagram-post>
          </ng-container>
        </div>
      </div>

    </div>
  </div>

  <!-- SIDEBAR -->
  <ng-container *ngTemplateOutlet="sidebarTpl"></ng-container>
</div>

<!-- ANALYTICS VIEW -->
<div class="grid grid-cols-1 xl:grid-cols-12" id="analyticsGrid" *ngIf="viewMode === 'analytics'">
  <div class="col-span-12 2xl:col-span-9 ps-3">
   <app-analytics
      [companyId]="companyID"
      [postingQueueId]="+id!"
      [tag]="tag!"
      [socialPlatformId]="null"
      [contentSiteId]="null">
    </app-analytics>

  </div>

  <!-- SIDEBAR -->
  <ng-container *ngTemplateOutlet="sidebarTpl"></ng-container>
</div>

<!-- SIDEBAR TEMPLATE (ONE COPY) -->
<ng-template #sidebarTpl>
  <div
    class="hidden md:block col-span-12 2xl:col-span-3 px-3 2xl:px-6 mt-6 2xl:mt-0"
    *ngIf="posts.length > 0"
  >
    <!-- LATEST POSTS -->
    <article class="p-8 bg-white rounded-2xl border border-gray-200 w-full">
      <h3 class="text-gray-700 mb-3 sm:mb-2">
        Latest posts
      </h3>

      <div>
        <ng-container *ngFor="let p of posts | slice:0:maxSidebarCards; trackBy: trackById; let last = last">
          <article class="bg-white/90 rounded-2xl py-4 sm:py-5">
            <div class="flex flex-col gap-2 sm:gap-1">
              <div class="flex flex-col sm:flex-row items-stretch gap-3">
                <div class="shrink-0 w-full sm:w-28">
                  <button
                    type="button"
                    class="aspect-video w-full overflow-hidden rounded-md bg-gray-100
                           cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-200"
                    (click)="viewRow(p)"
                    [attr.aria-label]="'Open ' + (p.rss_title || 'post')"
                  >
                    <img
                      class="w-full h-full object-cover"
                      [src]="p.image_url || naPlaceholder"
                      alt="{{ p.rss_title || 'Post image' }}"
                      (error)="onMainImgError($event)"
                    />
                  </button>
                </div>

                <div class="min-w-0 flex-1 flex flex-col mt-2 sm:mt-0">
                  <div
                    role="heading"
                    aria-level="3"
                    class="text-[13px] sm:text-[14px] font-normal text-gray-900 leading-snug
                           line-clamp-2 sm:line-clamp-3"
                    [matTooltip]="p.rss_title"
                  >
                    {{ p.rss_title || '—' }}
                  </div>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 text-[11px] text-gray-600">
                <div class="shrink-0 w-full sm:w-28 flex items-center justify-start sm:justify-center">
                  <span
                    class="truncate px-1 text-[10px] font-medium text-gray-500 uppercase tracking-wide"
                    [title]="p.domain_name || '—'"
                  >
                    {{ p.domain_name || '—' }}
                  </span>
                </div>

                <div class="flex-1 flex items-center gap-2">
                  <span
                    *ngIf="p.social_platform_title as plat"
                    class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                           border border-gray-200 bg-gray-50 max-w-[9rem] truncate text-[11px] font-medium"
                    [ngClass]="platformTextClass(plat)"
                    [title]="plat"
                  >
                    {{ plat }}
                  </span>

                  <button
                    type="button"
                    class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                           border border-gray-200 bg-transparent text-gray-700 text-[11px] font-medium
                           hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-200
                           cursor-pointer"
                    (click)="viewRow(p); $event.stopPropagation()"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </article>
        </ng-container>
      </div>
    </article>

    <!-- LATEST ALERTS -->
    <article class="p-8 bg-white rounded-2xl border border-gray-200 w-full mt-5" *ngIf="alerts.length > 0">
      <h3 class="text-gray-700 mb-3 sm:mb-2">
        Latest alerts
      </h3>

      <div>
        <ng-container *ngFor="let a of alerts | slice:0:maxSidebarCards; trackBy: trackByAlertId; let last = last">
          <article class="bg-white/90 rounded-2xl py-4 sm:py-5">
            <div class="flex flex-col gap-2 sm:gap-1">
              <div class="flex flex-col sm:flex-row items-stretch gap-3">
                <div class="shrink-0 w-full sm:w-28">
                  <button
                    type="button"
                    class="aspect-video w-full overflow-hidden rounded-md bg-gray-100
                           cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-200"
                    (click)="viewAlert(a)"
                    [attr.aria-label]="'Open ' + (a.rss_title || 'post')"
                  >
                    <img
                      class="w-full h-full object-cover"
                      [src]="a.rss_img_url || naPlaceholder"
                      alt="{{ a.rss_title || 'Post image' }}"
                      (error)="onMainImgError($event)"
                    />
                  </button>
                </div>

                <div class="min-w-0 flex-1 flex flex-col mt-2 sm:mt-0">
                  <div
                    role="heading"
                    aria-level="3"
                    class="text-[13px] sm:text-[14px] font-normal text-gray-900 leading-snug
                           line-clamp-2 sm:line-clamp-3"
                    [matTooltip]="a.rss_title"
                  >
                    {{ a.rss_title || '—' }}
                  </div>
                </div>
              </div>

              <div *ngIf="a.alert_type || a.alert_text" class="pl-5">
                <div
                  class="flex items-center gap-1 font-medium text-[13px]"
                  [ngClass]="{
                    'text-red-600': (a.alert_type || '').startsWith('Low'),
                    'text-green-600': (a.alert_type || '').includes('Spike')
                  }"
                >
                  <span class="text-sm">
                    {{ (a.alert_type || '').includes('Spike') ? '▲' : '▼' }}
                  </span>
                  <span class="truncate">
                    {{ a.alert_type }}
                    <span *ngIf="a.alert_text" class="text-xs text-gray-500 font-normal ml-2">
                      {{ a.alert_text }}
                    </span>
                  </span>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 text-[11px] text-gray-600">
                <div class="shrink-0 w-full sm:w-28 flex items-center justify-start sm:justify-center">
                  <span
                    class="truncate px-1 text-[10px] font-medium text-gray-500 uppercase tracking-wide"
                    [title]="a.Domain || '—'"
                  >
                    {{ a.Domain || '—' }}
                  </span>
                </div>

                <div class="flex-1 flex items-center gap-2">
                  <span
                    *ngIf="a.platform as plat"
                    class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                           border border-gray-200 bg-gray-50 max-w-[9rem] truncate text-[11px] font-medium"
                    [ngClass]="platformTextClass(plat)"
                    [title]="plat"
                  >
                    {{ plat }}
                  </span>

                  <button
                    type="button"
                    class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                           border border-gray-200 bg-transparent text-gray-700 text-[11px] font-medium
                           hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-200
                           cursor-pointer"
                    (click)="viewAlert(a); $event.stopPropagation()"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </article>
        </ng-container>
      </div>
    </article>
  </div>
</ng-template>
